const economicSectors = [
  {
    id: 'ES00',
    title: 'Sector primario privado',
    index: 1,
    helpKey: 'ES00H',
    color: '#5baa35',
    colorFilterValues: {
      invert: '53',
      sepia: '71',
      saturate: '399',
      hueRotate: '56',
      brightness: '93',
      contrast: '97'
    }
  },
  {
    id: 'ES01',
    title: 'Sector secundario privado',
    index: 2,
    helpKey: 'ES01H',
    color: '#5baa35',
    colorFilterValues: {
      invert: '53',
      sepia: '71',
      saturate: '399',
      hueRotate: '56',
      brightness: '93',
      contrast: '97'
    }
  },
  {
    id: 'ES02',
    title: 'Sector terciario privado',
    index: 3,
    helpKey: 'ES02H',
    color: '#5baa35',
    colorFilterValues: {
      invert: '53',
      sepia: '71',
      saturate: '399',
      hueRotate: '56',
      brightness: '93',
      contrast: '97'
    }
  },
  {
    id: 'ES03',
    title: 'Sectores públicos',
    index: 4,
    helpKey: 'ES03H',
    color: '#5baa35',
    colorFilterValues: {
      invert: '53',
      sepia: '71',
      saturate: '399',
      hueRotate: '56',
      brightness: '93',
      contrast: '97'
    }
  },
  {
    id: 'ES04',
    title: 'Cuarto sector',
    index: 5,
    helpKey: 'ES04H',
    color: '#5baa35',
    colorFilterValues: {
      invert: '53',
      sepia: '71',
      saturate: '399',
      hueRotate: '56',
      brightness: '93',
      contrast: '97'
    }
  },
  {
    id: 'ES05',
    title: 'Quinto sector',
    index: 6,
    helpKey: 'ES05H',
    color: '#5baa35',
    colorFilterValues: {
      invert: '53',
      sepia: '71',
      saturate: '399',
      hueRotate: '56',
      brightness: '93',
      contrast: '97'
    }
  }
]
export default economicSectors
